'use strict';

var SpinnerDirective = function () {
  var link = function () {};

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    link: link,
    templateUrl: 'dialogs/templates/spinner.tpl.html'
  };
};

module.exports = SpinnerDirective;



// WEBPACK FOOTER //
// ./src/app/dialogs/directives/SpinnerDirective.js